import React from 'react'

const MlAiProjectWindow = ({ title, description, img }) => {
    return (
        <div className="Project" data-aos="fade-up" data-aos-duration="1000">
            <div href="" className="Project--container" id="Project--container">
                <img src={img} alt="" className="Project--img" />
            </div>
            <p className="Project--Name">{title}</p>
            <p className="Project--Tech">{description}</p>
        </div>
    )
}

export default MlAiProjectWindow;